import { buildEnglishIqPath } from '@repo/config';
import type { EnglishIqMessagesType } from '../../english-iq-messages-type';

interface IEnglishIqV2FriendResultProps {
  locale: string;
  messages: EnglishIqMessagesType['v2']['start'];
  result: { score: number; subBand: string };
}

export function EnglishIqV2FriendResult({
  locale,
  messages,
  result,
}: IEnglishIqV2FriendResultProps): React.JSX.Element {
  const title = messages.friendTitle
    .replace('{subBand}', result.subBand)
    .replace('{score}', String(result.score));
  return (
    <main className="grid min-h-[100svh] place-items-center bg-[#100b08] px-5 py-10 text-[#fff8e9] sm:px-8">
      <div className="w-full max-w-3xl rounded-[2.5rem] border border-[#ff7a1a]/25 bg-[#fff8e9]/[0.04] p-8 shadow-2xl sm:p-14">
        <p className="text-xs font-bold uppercase tracking-[0.24em] text-[#ff9b50]">
          {messages.friendEyebrow}
        </p>
        <h1 className="mt-5 text-balance text-5xl font-semibold leading-[0.95] tracking-[-0.05em] sm:text-7xl">
          {title}
        </h1>
        <p className="mt-7 text-lg leading-8 text-[#f7edda]/68">{messages.friendBody}</p>
        <a
          className="mt-9 inline-flex min-h-14 items-center rounded-full bg-[#ff7a1a] px-8 font-extrabold text-[#160c06] shadow-[0_12px_45px_rgba(255,122,26,0.28)]"
          href={buildEnglishIqPath(locale === 'en' ? undefined : locale)}
        >
          {messages.friendCta}
        </a>
      </div>
    </main>
  );
}
